import Initializer from "./Controllers/Blocks/Initializer";
import Waypoint from "./Controllers/Waypoint";
import DelayedClassAssignment from "./Controllers/DelayedClassAssignment";
import SiteHeader from "./Controllers/SiteHeader";
import FullscreenElement from "./Controllers/FullscreenElement";
import MiscComponentInitializer from "./MiscComponentInitializer";
import MobileMenu from "./Controllers/MobileMenu";
import SiteFooter from "./Controllers/SiteFooter";
import FsLightboxInitilaizer from "./Controllers/FsLightboxInitializer";
import GoogleMap from "./Controllers/GoogleMap";
import AutoExpandTextarea from "./Controllers/AutoExpandTextarea";
import AdaCompliance from "./Controllers/AdaCompliance";
import Cards from "./Controllers/Cards";
import PostCards from "./Controllers/PostCards";
import Blog from "./Controllers/Blog";
import GravityForms from "./Controllers/GravityForms";
import BusinessHours from "./Controllers/BusinessHours";
import SearchAutoComplete from "./Controllers/SearchAutoComplete";
import ParallaxScrollingElementCollection from "./Controllers/ParallaxScrollingElementCollection";
import PostLoaderCollection from "./Controllers/PostLoaderCollection";
import debounce from "debounce";
import DefaultHero from "./Controllers/DefaultHero";

class Main {
	static instance;

	/**
	 * @type {*}
	 */
	debounce = debounce;

	/**
	 * @return {Main}
	 * @constructor
	 */
	static get Instance() {
		return Main.instance;
	}

	constructor() {
		Main.instance = this;

		/**
		 * @type {SiteHeader}
		 */
		this.header = null;
		/**
		 * @type {SiteFooter}
		 */
		this.footer = null;
		/**
		 * @type {MobileMenu}
		 */
		this.mobileMenu = null;

		this.url = {
			home: "",
			tpl: "",
			ajax: "",
		};

		this.path = {
			tpl: "",
		};

		window.document.addEventListener("DOMContentLoaded", this.init.bind(this));
	}

	/**
	 * @return {SiteHeader}
	 */
	getHeaderController() {
		return this.header;
	}

	/**
	 * @return {SiteFooter}
	 */
	getFooterController() {
		return this.footer;
	}

	/**
	 * @return {MobileMenu}
	 */
	getMobileMenuController() {
		return this.mobileMenu;
	}

	init() {
		document.documentElement.setAttribute("data-agent", navigator.userAgent);
		document.body.classList.add("loaded");

		this.header = this.initializeSiteHeader();
		this.footer = this.initializeSiteFooter();
		this.mobileMenu = this.initializeMobileMenu();
		this.miscCompInitializer = this.initializeMiscComponents();
		this.animDelayer = this.initializeDelayedClassAssigment();
		this.postLoaders = this.initializePostLoaderCollection();

		this.initializeWaypoints();
		this.initializeFullscreenElements();
		this.initializeFsLightbox();
		this.initializeAutoExandTextAreas();
		this.initializeCards();
		this.initializePostCards();
		this.initializeBlocks();
		this.initializeBlog();
		this.initializeGravityForms();
		this.initializeGoogleMaps();
		this.initializeDefaultHero();
		this.initializeAdaCompliance();
		this.initializeBusinessHours();
		this.initializeSearchAutoComplete();
		this.initializeParallaxScrollingElementsCollection();
	}

	/**
	 *
	 * @return {SiteHeader}
	 */
	initializeSiteHeader() {
		return new SiteHeader(this);
	}

	/**
	 * @return {SiteFooter}
	 */
	initializeSiteFooter() {
		return new SiteFooter(this);
	}

	/**
	 * @return {MobileMenu}
	 */
	initializeMobileMenu() {
		return new MobileMenu(this);
	}

	/**
	 *
	 * @return {DelayedClassAssignment}
	 */
	initializeDelayedClassAssigment() {
		return new DelayedClassAssignment();
	}

	/**
	 *
	 * @return {Waypoint}
	 */
	initializeWaypoints() {
		return new Waypoint(".waypoint");
	}

	/**
	 * @return {FullscreenElement}
	 */
	initializeFullscreenElements() {
		return new FullscreenElement(".fullscreen");
	}

	/**
	 * @return {GravityForms}
	 */
	initializeGravityForms() {
		return new GravityForms();
	}

	/**
	 * @return {FsLightboxInitilaizer}
	 */
	initializeFsLightbox() {
		return new FsLightboxInitilaizer("a.popup");
	}

	/**
	 *
	 * @return {AutoExpandTextarea}
	 */
	initializeAutoExandTextAreas() {
		return new AutoExpandTextarea("textarea");
	}

	/**
	 * @return {Cards}
	 */
	initializeCards() {
		return new Cards();
	}

	/**
	 *
	 * @return {PostCards}
	 */
	initializePostCards() {
		return new PostCards();
	}

	/**
	 * @return {Blog}
	 */
	initializeBlog() {
		return new Blog();
	}

	initializeGoogleMaps() {
		document.querySelectorAll(".acf-map").forEach((mapEl) => {
			new GoogleMap(mapEl);
		});
	}

	/**
	 *
	 * @return {Initializer}
	 */
	initializeBlocks() {
		return new Initializer();
	}

	/**
	 * @return {MiscComponentInitializer}
	 */
	initializeMiscComponents() {
		return new MiscComponentInitializer();
	}

	/**
	 * @return {AdaCompliance}
	 */
	initializeAdaCompliance() {
		return new AdaCompliance();
	}

	/**
	 * @return {BusinessHours}
	 */
	initializeBusinessHours() {
		return new BusinessHours();
	}

	/**
	 * @returns {SearchAutoComplete}
	 */
	initializeSearchAutoComplete() {
		return new SearchAutoComplete();
	}

	/**
	 * @returns {ParallaxScrollingElementCollection}
	 */
	initializeParallaxScrollingElementsCollection() {
		return new ParallaxScrollingElementCollection(".parallax-container");
	}

	/**
	 * @returns {PostLoaderCollection}
	 */
	initializePostLoaderCollection() {
		return new PostLoaderCollection();
	}

	/**
	 * @return {DefaultHero}
	 */
	initializeDefaultHero() {
		return new DefaultHero(window.document.querySelector(".section.default-hero"));
	}
}

export default Main;
